<template>

  <AnalisiFornitori />

</template>

<script>
import AnalisiFornitori from '../components/pratiche/AnalisiFornitori.vue'

export default {
  pageName: 'AnalisiFornitori',
  components: {
    AnalisiFornitori

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
